import { initialize as initLaunchDarkly, LDClient } from 'launchdarkly-js-client-sdk';

const envKeys = {
  prod: '5f6129460c70fc0aad284e6c',
  production: '5f6129460c70fc0aad284e6c',
  uat: '5fd1574d04d4e20b1056e514',
  env1: '5fd40206dd96e30a08444cf4',
  env2: '5fd402160bfe6d0a3ac8b57b',
  env3: '5fd402211333ce09eb1960c1',
  env4: '5fd4022b1333ce09eb1960c8',
  env5: '5fd40238e37ff609c08d9b48',
  env6: '5fd402470bfe6d0a3ac8b58a',
  env7: '5fd1572ca7a8d30afe8d9988',
  env8: '5fd402521333ce09eb1960d3',
  env9: '5fd40260e37ff609c08d9b50',
};
const DEFAULT_LD_USER_KEY = 'anonymous';

const urlParams = new URLSearchParams(window.location.search);

export type FeatureFlags = {
  [k: string]: unknown;
  AUDIO_FIX_TARGET_IOS_VERSIONS_JSON?: string | undefined;
  AUDIO_FIX_GAIN_LEVEL?: number | undefined;
};

export let featureFlags: FeatureFlags = {};
let launchDarklyClient: LDClient = null;

export function initializeLaunchDarkly(apiEnv: string) {
  if (launchDarklyClient) {
    console.error('LaunchDarkly Client has already been initialized.');
    return;
  }

  const envKey = envKeys[apiEnv] || envKeys.prod;
  launchDarklyClient = initLaunchDarkly(envKey, {
    key: DEFAULT_LD_USER_KEY,
  });

  launchDarklyClient.on('ready', () => {
    featureFlags = getAllFlags();
    window.featureFlags = featureFlags;
  });
}

export function registerNewLDUserKey(orgId: string) {
  if (
    !featureFlags ||
    !featureFlags['should-enable-patient-org-variations'] ||
    !launchDarklyClient
  ) {
    return;
  }

  const launchDarklyUserKey = launchDarklyClient.getUser().key;
  if (launchDarklyUserKey === orgId) return;

  launchDarklyClient.identify({ key: orgId || DEFAULT_LD_USER_KEY }).then((newFlags) => {
    featureFlags = newFlags;
    window.featureFlags = featureFlags;
  });
}

function getAllFlags() {
  if (!launchDarklyClient) {
    console.error('LaunchDarkly Client is not initialized.');
    return;
  }

  return launchDarklyClient.allFlags();
}

export function isEmailInviteFeatureFlagEnabled() {
  return !!featureFlags?.emailInvite || urlParams.get('emailInvite') === 'true';
}

export function isCameraFlipFeatureFlagEnabled() {
  return !!featureFlags?.cameraFlip || urlParams.get('cameraFlip') === 'true';
}

// Gain number too loud will make audio start clipping, we can adjust this if not loud enough
export function AUDIO_FIX_GAIN_LEVEL(): number {
  const DEFAULT_AUDIO_FIX_GAIN_LEVEL = 10;
  const queryParam =
    !isNaN(parseInt(urlParams.get('audioFixGainLevel'))) &&
    parseInt(urlParams.get('audioFixGainLevel'));

  return (
    (urlParams.get('audioFixGainLevel') && queryParam) ||
    featureFlags?.AUDIO_FIX_GAIN_LEVEL ||
    DEFAULT_AUDIO_FIX_GAIN_LEVEL
  );
}

// iOS versions we want to target to apply our audio fix to
export function AUDIO_FIX_TARGET_IOS_VERSIONS(): string[] {
  const versionsMap = featureFlags?.AUDIO_FIX_TARGET_IOS_VERSIONS_JSON;
  let versions = ['15.0', '15.1', '15.2', '15.3'];
  if (versionsMap) {
    versions = Object.keys(versionsMap);
  }
  return versions;
}
